export const BRAND_NAME = 'StarCoinExchange';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'starcoinexchange.com';
export const PROVIDER_ID = 'BetFair';
